// extracted by mini-css-extract-plugin
export default {"container":"ResetGatewayPassword_container__urLDl","inputBox":"ResetGatewayPassword_inputBox__W+veF"};